import { Link } from 'react-router-dom';
import { Mail, Linkedin, MapPin } from 'lucide-react';
import { usePortalConfig } from '@shared/config';

export function Footer() {
  const { branding, partnership } = usePortalConfig();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background border-t border-border pt-16 pb-8">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* Branding */}
          <div>
            <h3 className="font-bold text-lg mb-4 text-foreground">{branding.name}</h3>
            <p className="text-muted-foreground text-sm leading-relaxed mb-6">
              Uw toegang tot Nederlandse jurisprudentie en rechtspraak. Slimmer werken met AI-ondersteunde zoektechnologie.
            </p>
            {/* Partnership */}
            {partnership && (
              <div className="mt-6">
                <p className="text-muted-foreground text-sm mb-2">{partnership.label}</p>
                <div className="flex items-center gap-3 flex-wrap">
                  {partnership.partners.map((partner, index) => {
                    const img = (
                      <img
                        key={partner.name}
                        src={partner.logo}
                        alt={partner.name}
                        className={`${partner.logoHeight ?? 'h-6'} object-contain`}
                      />
                    );
                    const logo = partner.url ? (
                      <a
                        key={partner.name}
                        href={partner.url}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {img}
                      </a>
                    ) : (
                      img
                    );
                    return (
                      <>
                        {index > 0 && <span key={`x-${index}`} className="text-muted-foreground text-xs">x</span>}
                        {logo}
                      </>
                    );
                  })}
                </div>
              </div>
            )}
          </div>

          {/* Links */}
          <div>
            <h3 className="font-bold text-lg mb-4 text-foreground">Links</h3>
            <ul className="space-y-3 text-sm text-muted-foreground">
              <li>
                <Link to="/search" className="hover:text-primary transition-colors">
                  Zoeken
                </Link>
              </li>
              <li>
                <Link to="/recent" className="hover:text-primary transition-colors">
                  Recente uitspraken
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="hover:text-primary transition-colors">
                  Privacybeleid
                </Link>
              </li>
            </ul>
            <a
              href={branding.linkedInUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-4 inline-block text-muted-foreground hover:text-primary transition-colors"
              aria-label="LinkedIn"
            >
              <Linkedin className="h-6 w-6" />
            </a>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-bold text-lg mb-4 text-foreground">Contact</h3>
            <p className="text-muted-foreground text-sm mb-4">
              Voor vragen of ondersteuning kunt u contact met ons opnemen.
            </p>
            <ul className="space-y-3 text-sm text-muted-foreground">
              <li>
                <a
                  href={`mailto:${branding.contactEmail}`}
                  className="inline-flex items-center gap-2 hover:text-primary transition-colors"
                >
                  <Mail className="h-4 w-4 shrink-0 text-primary" />
                  {branding.contactEmail}
                </a>
              </li>
              <li className="inline-flex items-start gap-2">
                <MapPin className="h-4 w-4 mt-0.5 shrink-0 text-primary" />
                <span>Schiedamsedijk 42<br />3011 ED Rotterdam</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-border text-center">
          <p className="text-muted-foreground text-sm">
            &copy; {currentYear} {branding.name}. Alle rechten voorbehouden.
          </p>
        </div>

      </div>
    </footer>
  );
}
